/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseClient } from '../base-client';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { addUserToRole } from '../fn/tenant-security/add-user-to-role';
import { AddUserToRole$Params } from '../fn/tenant-security/add-user-to-role';
import { createUser } from '../fn/tenant-security/create-user';
import { CreateUser$Params } from '../fn/tenant-security/create-user';
import { deleteUser } from '../fn/tenant-security/delete-user';
import { DeleteUser$Params } from '../fn/tenant-security/delete-user';
import { TenantUserDto as FeatureTenantSecurityTenantUserDto } from '../models/feature/tenant-security/tenant-user-dto';
import { getUsers } from '../fn/tenant-security/get-users';
import { GetUsers$Params } from '../fn/tenant-security/get-users';
import { removeUserFromRole } from '../fn/tenant-security/remove-user-from-role';
import { RemoveUserFromRole$Params } from '../fn/tenant-security/remove-user-from-role';
import { resetUserPassword } from '../fn/tenant-security/reset-user-password';
import { ResetUserPassword$Params } from '../fn/tenant-security/reset-user-password';
import { UserDto as SecurityUserDto } from '../models/security/user-dto';

@Injectable({ providedIn: 'root' })
export class TenantSecurityClient extends BaseClient {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `tenantSecurityGetUsers()` */
  static readonly TenantSecurityGetUsersPath = '/users';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUsers()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUsers$Response(context?: HttpContext): Observable<StrictHttpResponse<Array<FeatureTenantSecurityTenantUserDto>>> {
    const obs = getUsers(this.http, this.rootUrl, {} satisfies GetUsers$Params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUsers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUsers(context?: HttpContext): Observable<Array<FeatureTenantSecurityTenantUserDto>> {
    const resp = this.getUsers$Response(context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<FeatureTenantSecurityTenantUserDto>>): Array<FeatureTenantSecurityTenantUserDto> => r.body)
    );
  }

  /** Path part for operation `tenantSecurityCreateUser()` */
  static readonly TenantSecurityCreateUserPath = '/users';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createUser()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createUser$Response(body: CreateUser$Params['body'], context?: HttpContext): Observable<StrictHttpResponse<SecurityUserDto>> {
    const obs = createUser(this.http, this.rootUrl, { body } satisfies CreateUser$Params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createUser$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createUser(body: CreateUser$Params['body'], context?: HttpContext): Observable<SecurityUserDto> {
    const resp = this.createUser$Response(body, context);
    return resp.pipe(
      map((r: StrictHttpResponse<SecurityUserDto>): SecurityUserDto => r.body)
    );
  }

  /** Path part for operation `tenantSecurityAddUserToRole()` */
  static readonly TenantSecurityAddUserToRolePath = '/users/{userId}/role/{roleName}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addUserToRole()` instead.
   *
   * This method doesn't expect any request body.
   */
  addUserToRole$Response(userId: string, roleName: AddUserToRole$Params['roleName'], context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = addUserToRole(this.http, this.rootUrl, { userId, roleName } satisfies AddUserToRole$Params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addUserToRole$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  addUserToRole(userId: string, roleName: AddUserToRole$Params['roleName'], context?: HttpContext): Observable<void> {
    const resp = this.addUserToRole$Response(userId, roleName, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `tenantSecurityRemoveUserFromRole()` */
  static readonly TenantSecurityRemoveUserFromRolePath = '/users/{userId}/role/{roleName}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `removeUserFromRole()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeUserFromRole$Response(userId: string, roleName: RemoveUserFromRole$Params['roleName'], context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = removeUserFromRole(this.http, this.rootUrl, { userId, roleName } satisfies RemoveUserFromRole$Params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `removeUserFromRole$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeUserFromRole(userId: string, roleName: RemoveUserFromRole$Params['roleName'], context?: HttpContext): Observable<void> {
    const resp = this.removeUserFromRole$Response(userId, roleName, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `tenantSecurityDeleteUser()` */
  static readonly TenantSecurityDeleteUserPath = '/users/{userId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteUser$Response(userId: string, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteUser(this.http, this.rootUrl, { userId } satisfies DeleteUser$Params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteUser(userId: string, context?: HttpContext): Observable<void> {
    const resp = this.deleteUser$Response(userId, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `tenantSecurityResetUserPassword()` */
  static readonly TenantSecurityResetUserPasswordPath = '/users/{userId}/reset-password';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resetUserPassword()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  resetUserPassword$Response(userId: string, body: ResetUserPassword$Params['body'], context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = resetUserPassword(this.http, this.rootUrl, { userId, body } satisfies ResetUserPassword$Params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `resetUserPassword$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  resetUserPassword(userId: string, body: ResetUserPassword$Params['body'], context?: HttpContext): Observable<void> {
    const resp = this.resetUserPassword$Response(userId, body, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
